var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      on: {
        "click:outside": function ($event) {
          _vm.showMonthlyTimeReport = false
        },
      },
      model: {
        value: _vm.showMonthlyTimeReport,
        callback: function ($$v) {
          _vm.showMonthlyTimeReport = $$v
        },
        expression: "showMonthlyTimeReport",
      },
    },
    [
      _c(
        "v-overlay",
        { attrs: { value: _vm.loaderOverlay, absolute: true } },
        [
          _c(
            "v-row",
            { attrs: { justify: "center" } },
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", size: "120" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-card",
        { attrs: { id: "timeReport", "min-height": "90vh" } },
        [
          _c(
            "v-card-title",
            { staticClass: "mb-0 pb-0" },
            [
              _c("v-col", { attrs: { cols: "4" } }),
              _c(
                "v-col",
                { attrs: { cols: "4" } },
                [
                  _c("v-row", { attrs: { justify: "center" } }, [
                    _vm.isTimespan
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              "font-size": "28px",
                              "font-weight": "bold",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  `${_vm.$t("timeReport")} ${
                                    _vm.fromDateAsString
                                  } - ${_vm.toDateAsString}`
                                ) +
                                " "
                            ),
                          ]
                        )
                      : _c(
                          "div",
                          {
                            staticClass: "ml-12",
                            staticStyle: {
                              "font-size": "28px",
                              "font-weight": "bold",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("timeReport") +
                                    " " +
                                    _vm.monthAsString +
                                    " " +
                                    _vm.yearAsString
                                ) +
                                " "
                            ),
                          ]
                        ),
                  ]),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "3" } },
                [
                  _c(
                    "v-row",
                    [
                      _vm.users.length > 1
                        ? _c("v-col", {
                            staticClass: "d-flex justify-end",
                            attrs: { cols: "4" },
                          })
                        : _vm._e(),
                      _vm.users.length == 1 ? _c("v-spacer") : _vm._e(),
                      _c(
                        "v-col",
                        {
                          staticClass: "d-flex justify-end",
                          attrs: { cols: "8" },
                        },
                        [
                          _c("v-select", {
                            staticClass: "pr-2",
                            attrs: {
                              items: _vm.exportType,
                              label: _vm.$t("exportType"),
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.selectedExportType,
                              callback: function ($$v) {
                                _vm.selectedExportType = $$v
                              },
                              expression: "selectedExportType",
                            },
                          }),
                          _c(
                            "v-btn",
                            {
                              staticClass: "mr-2",
                              attrs: { color: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.exportReports()
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("exportBtnAll")))]
                          ),
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.exportReport()
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("exportBtn")))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "1" } },
                [
                  _c(
                    "v-row",
                    { attrs: { "no-gutters": "" } },
                    [
                      _c(
                        "v-col",
                        { staticClass: "d-flex justify-end" },
                        [
                          _c(
                            "v-btn",
                            { attrs: { icon: "" }, on: { click: _vm.back } },
                            [_c("v-icon", [_vm._v("mdi-close")])],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mb-2", attrs: { "no-gutters": "" } },
                [
                  !_vm.isTimespan
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "mt-6",
                          style: { cursor: "pointer" },
                          attrs: { icon: "", text: "" },
                          on: {
                            click: function ($event) {
                              return _vm.changeMonth(-1)
                            },
                          },
                        },
                        [
                          _c("v-icon", { attrs: { large: "" } }, [
                            _vm._v("mdi-arrow-left"),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("v-spacer"),
                  _c(
                    "v-col",
                    { attrs: { cols: "3" } },
                    [
                      _c("v-select", {
                        staticClass: "select",
                        attrs: {
                          "item-text": "name",
                          items: _vm.users,
                          "return-object": "",
                          readonly: _vm.simplyReport,
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.selectedUser,
                          callback: function ($$v) {
                            _vm.selectedUser = $$v
                          },
                          expression: "selectedUser",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("v-spacer"),
                  !_vm.isTimespan
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "mt-6",
                          style: { cursor: "pointer" },
                          attrs: { icon: "", text: "" },
                          on: {
                            click: function ($event) {
                              return _vm.changeMonth(1)
                            },
                          },
                        },
                        [
                          _c("v-icon", { attrs: { large: "" } }, [
                            _vm._v("mdi-arrow-right"),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _c("v-data-table", {
                staticClass: "elevation-1",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.selectedEmployee,
                  "item-key": "date",
                  dense: "",
                  "items-per-page": -1,
                  "fixed-header": "",
                  "hide-default-footer": "",
                  "item-class": _vm.getRowClass,
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.calenderWeek",
                    fn: function ({ item }) {
                      return [
                        item.calenderWeek
                          ? _c(
                              "v-row",
                              {
                                staticClass: "pa-2",
                                attrs: { justify: "center" },
                              },
                              [
                                Number.isInteger(item.calenderWeek)
                                  ? _c("td", { staticClass: "bold" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("calenderWeek") +
                                              item.calenderWeek +
                                              ":"
                                          ) +
                                          " "
                                      ),
                                    ])
                                  : _c("td", [
                                      _vm._v(
                                        " " + _vm._s(item.calenderWeek) + " "
                                      ),
                                    ]),
                              ]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                  {
                    key: "item.date",
                    fn: function ({ item }) {
                      return [
                        _c("v-row", [
                          item.date === "overallPeriod"
                            ? _c("td", { staticClass: "bold" }, [
                                _vm._v(" " + _vm._s(_vm.$t(item.date)) + " "),
                              ])
                            : _c("td", [_vm._v(" " + _vm._s(item.date) + " ")]),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "item.absence",
                    fn: function ({ item }) {
                      return [
                        item.absence != null && item.absence.factor == 1
                          ? _c(
                              "div",
                              { style: _vm.setStyleForAbsence(item.absence) },
                              [_vm._v(_vm._s(item.absence.reason.charAt(0)))]
                            )
                          : item.absence != null && item.absence.factor != 1
                          ? _c(
                              "div",
                              { style: _vm.setStyleForAbsence(item.absence) },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      item.absence.reason.charAt(0) + "/2"
                                    ) +
                                    " "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c(
                "v-row",
                { attrs: { "no-gutters": "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "3" } },
                    [
                      _c("v-simple-table", { staticClass: "mt-6" }, [
                        _c("thead", [
                          _c("tr", [
                            _c("th"),
                            _c("th", [_vm._v(_vm._s(_vm.$t("descriptions")))]),
                            _c("th", [_vm._v(_vm._s(_vm.$t("timeValue")))]),
                          ]),
                        ]),
                        _c(
                          "tbody",
                          _vm._l(_vm.accountSummary, function (row, i) {
                            return _c("tr", { key: i }, [
                              _c(
                                "td",
                                { staticStyle: { "text-align": "right" } },
                                [_vm._v(_vm._s(row.operators))]
                              ),
                              _c("td", [_vm._v(_vm._s(_vm.$t(row.text)))]),
                              _c("td", [_vm._v(_vm._s(row.value))]),
                            ])
                          }),
                          0
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm.selectedEmployee.length != 0
                    ? _c(
                        "v-col",
                        { staticClass: "ml-6", attrs: { cols: "3" } },
                        [
                          _c("v-simple-table", { staticClass: "mt-6" }, [
                            _c("thead", [
                              _c("tr", [
                                _c("th", [
                                  _vm._v(_vm._s(_vm.$t("descriptions"))),
                                ]),
                                _c("th", [_vm._v(_vm._s(_vm.$t("timeValue")))]),
                              ]),
                            ]),
                            _c(
                              "tbody",
                              [
                                _c("tr", [
                                  _c("td", [
                                    _vm._v(_vm._s(_vm.$t("totalVacation"))),
                                  ]),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(_vm.vacationSummary.totalDays)
                                    ),
                                  ]),
                                ]),
                                _c("tr", [
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.isTimespan
                                          ? _vm
                                              .$t("vacationTakenBeforeDate")
                                              .format(_vm.fromDateAsString)
                                          : _vm.$t("vacationTakenPrevMonth")
                                      )
                                    ),
                                  ]),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(_vm.vacationSummary.usedPreMonths)
                                    ),
                                  ]),
                                ]),
                                _c("tr", [
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.isTimespan
                                          ? _vm.$t("vacationTakenInPeriod")
                                          : _vm.$t("vacationTakenThisMonth")
                                      )
                                    ),
                                  ]),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(_vm.vacationSummary.usedThisMonth)
                                    ),
                                  ]),
                                ]),
                                _c("tr", [
                                  _c("td", [
                                    _vm._v(_vm._s(_vm.$t("remainingVacation"))),
                                  ]),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(_vm.vacationSummary.remainingDays)
                                    ),
                                  ]),
                                ]),
                                _c("tr", [_c("td"), _c("td")]),
                                _vm._l(
                                  Object.keys(_vm.absencesSummary),
                                  function (absence) {
                                    return _c("tr", { key: absence }, [
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            absence + " " + _vm.$t("total")
                                          )
                                        ),
                                      ]),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.calculateAbsences(
                                              _vm.absencesSummary[absence]
                                            )
                                          )
                                        ),
                                      ]),
                                    ])
                                  }
                                ),
                              ],
                              2
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("v-spacer"),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }